module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question7.d97ee54c.jpg";